export const OrderProblem = {
  UNSAVED: 'Unsaved',
  UNSENT: 'Unsent',
  UNCONFIRMED: 'Unconfirmed'
} as const;
export type OrderProblemType = (typeof OrderProblem)[keyof typeof OrderProblem];

export interface StreamingOrder {
  id: number | string;
  revision: number | string;
  status: number;
  network: string;
  platforms?: string[];
  descriptions?: string[];
  start: string;
  end: string;
  spend: string | number | null;
  lastuser?: string;
}

export interface OrderPdfEntry {
  sent?: string;
  approved?: string;
}

export const statusToLabel = (status: number): string => {
  let label: string;
  switch (status) {
    case 20:
      label = 'Confirmed';
      break;
    case 11:
      label = 'Sent';
      break;
    case 30:
      // Cancelled / rolled back (e.g. an agent order a reviewer cancelled). Must
      // be distinct from "Pending" so audits don't read a rollback as still-open.
      label = 'Cancelled';
      break;
    default:
      label = 'Pending';
  }
  return `${label} (${status})`;
};
